import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import USACalculator from "@/components/USACalculator";
import EuroCalculator from "@/components/EuroCalculator";

export default function CalculatorHub({ open, onOpenChange }) {
  const [mode, setMode] = useState(null); // null | "usa" | "europe"

  useEffect(() => {
    if (open) setMode(null);
  }, [open]);

  return (
    <Drawer open={open} onOpenChange={onOpenChange} shouldScaleBackground={false}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle className="font-heading">PRICE CALCULATOR</DrawerTitle>
        </DrawerHeader>
        <div className="max-h-[80vh] space-y-3 overflow-y-auto px-4 pb-8" data-testid="calculator-hub">
          {!mode ? (
            <div className="grid grid-cols-2 gap-3" data-testid="calculator-hub-choices">
              <button
                type="button"
                data-testid="calc-choice-usa"
                onClick={() => setMode("usa")}
                className="flex h-20 flex-col items-center justify-center gap-1 rounded-lg border text-base font-extrabold transition-colors hover:bg-accent active:scale-[0.98]"
              >
                <span className="text-2xl">🇺🇸</span> USA
              </button>
              <button
                type="button"
                data-testid="calc-choice-europe"
                onClick={() => setMode("europe")}
                className="flex h-20 flex-col items-center justify-center gap-1 rounded-lg border text-base font-extrabold transition-colors hover:bg-accent active:scale-[0.98]"
              >
                <span className="text-2xl">🇪🇺</span> EUROPE
              </button>
            </div>
          ) : (
            <>
              <button
                type="button"
                data-testid="calc-back-button"
                onClick={() => setMode(null)}
                className="flex items-center gap-1 text-xs font-bold text-primary"
              >
                <ArrowLeft className="h-3.5 w-3.5" /> Change calculator
              </button>
              {mode === "usa" ? <USACalculator /> : <EuroCalculator />}
            </>
          )}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
